import React from 'react'
import { Link } from 'react-router-dom'
import NotFoundImg from '../../Assets/images/404-img.png'


function PageNotFound() {
  return (
    <>
       <main>
        <section className="page-not-found" >
          <div className='container'>
            <img className='img-404' src={NotFoundImg} alt="" />
            <h1 className='not-txt'>Page Not Found</h1>
            <Link className='btn-404 round-btn' to="/">Go To Home</Link>
          </div>
        </section>
    </main>
    </>
  )
}

export default PageNotFound